require("jquery");
///// <reference path="jquery.js" />
/*jslint browser: true, maxerr: 50, indent: 4 */
/*global jQuery:true */

(function ($) {
    "use strict";
    $.getAntiForgeryToken = function (tokenWindow, appPath) {
        var inputElements, i, inputElement, tokenName;
        // HtmlHelper.AntiForgeryToken() must be invoked to print the token.
        tokenWindow = tokenWindow && typeof tokenWindow === typeof window ? tokenWindow : window;

        appPath = appPath && typeof appPath === "string" ? "_" + appPath.toString() : "";
        // The name attribute is either __RequestVerificationToken,
        // or __RequestVerificationToken_{appPath}.
        tokenName = "__RequestVerificationToken" + appPath;

        // Finds the <input type="hidden" name={tokenName} value="..." /> from the specified window.
        // var inputElements = tokenWindow.$("input[type='hidden'][name=' + tokenName + "']");
        inputElements = tokenWindow.document.getElementsByTagName("input");
        for (i = 0; i < inputElements.length; i += 1) {
            inputElement = inputElements[i];
            if (inputElement.type === "hidden" && inputElement.name === tokenName) {
                return {
                    name: tokenName,
                    value: inputElement.value
                };
            }
        }
        return undefined;
    };

    $.appendAntiForgeryToken = function (data, token) {
        // Converts data if not already a string.
        if (data && typeof data !== "string") {
            data = $.param(data);
        }

        // Gets token from current window by default.
        if (!token) {
            token = $.getAntiForgeryToken();
        }

        data = data ? data + "&" : "";
        // If token exists, appends {token.name}={token.value} to data.
        return token ? data + encodeURIComponent(token.name) + "=" + encodeURIComponent(token.value) : data;
    };

    // Wraps $.post(url, data, callback, type) for most common scenarios.
    $.postAntiForgery = function (url, data, callback, type) {
        return $.post(url, $.appendAntiForgeryToken(data), callback, type);
    };

    // Wraps $.ajax(settings).
    $.ajaxAntiForgery = function (settings) {
        // Supports more options than $.ajax(): 
        // settings.token, settings.tokenWindow, settings.appPath.
        var token;
        if (settings.token) {
            token = settings.token;
        } else {
            token = $.getAntiForgeryToken(settings.tokenWindow, settings.appPath);
        }
        settings.data = $.appendAntiForgeryToken(settings.data, token);
        return $.ajax(settings);
    };
}(jQuery));